import Button from '@/components/Button.jsx';
import WizardInfoBox from '@/components/wizard/WizardInfoBox.jsx';

const resourceLabels = {
  gravity_workflow: 'Gravity workflows',
  cirra_workflow: 'Cirra workflows',
  task: 'Tasks',
  analytics_data_source: 'Analytics data sources',
  trigger: 'Triggers'
};

const CredentialEditWarning = ({ warning, onCancel }) => {
  if (!warning.required) {
    return null;
  }

  if (!warning.blocked) {
    return (
      <WizardInfoBox className="comp-credential-edit-warning">
        <p>Shared connection: changes may interrupt the workflows, tasks, analytics, and triggers that use it.</p>
      </WizardInfoBox>
    );
  }

  const isLoading = !warning.impact || warning.impact.status === 'loading';
  const isUnavailable = warning.impact?.status === 'unavailable';
  const rows = warning.impact?.rows || [];

  return (
    <WizardInfoBox className="comp-credential-edit-warning">
      <div role="status" aria-live="polite">
        <strong>Changes can interrupt shared connections</strong>
        <p>This is a shared organization connection. Changing its settings or signing in with another account may interrupt the workflows, tasks, analytics, and triggers that use it.</p>
        {isLoading && <p>Loading known saved references…</p>}
        {isUnavailable && <p>Dependency information is unavailable. Other integrations may still depend on this connection.</p>}
        {!isLoading && !isUnavailable && (
          <>
            <p>Known saved references:</p>
            {rows.length > 0 ? (
              <ul>
                {rows.map((row) => (
                  <li key={row.resourceType}>
                    {resourceLabels[row.resourceType]}: {row.count}
                  </li>
                ))}
              </ul>
            ) : (
              <p>No saved references found.</p>
            )}
            <p>Default or dynamically selected connections may have additional dependencies.</p>
          </>
        )}
      </div>
      {warning.blocked && (
        <div className="credential-edit-warning-actions">
          <Button autoFocus onClick={onCancel}>
            Cancel
          </Button>
          <Button className="primary" disabled={isLoading} onClick={warning.acknowledge}>
            Continue editing
          </Button>
        </div>
      )}
    </WizardInfoBox>
  );
};

export default CredentialEditWarning;
